import { createActions } from 'redux-actions';
import * as types from 'actions/countries/types';

export default createActions({}, ...Object.values(types));
